import StaticPageContent from '@map/components/StaticPageContent';
import { Alert, LinearProgress } from '@mui/material';
import { HTMLAttributes, forwardRef, useEffect, useState, type ReactNode } from 'react';
import TranslationLanguageMenu from './TranslationLanguageMenu';

type Props = HTMLAttributes<HTMLDivElement> & {
  contents: Record<string, string>;
  currentId: string;
  disclaimerText?: ReactNode;
  translator: (contentId: string, locale: string) => Promise<string>;
};
const TranslatablePageContents: FFC<Props> = (props, ref) => {
  const { contents, currentId, translator, disclaimerText, ...restProps } = props;
  const [isTranslating, setTranslating] = useState(false);
  const [translatedContents, setTranslatedContents] = useState<Record<string, string>>({});
  const [translationLanguage, setTranslationLanguage] = useState('');
  useEffect(() => {
    if (translationLanguage) {
      setTranslatedContents((v) => ({ ...v, [currentId]: ' ' }));
      setTranslating(true);
      translator(currentId, translationLanguage)
        .then((result) => setTranslatedContents((v) => ({ ...v, [currentId]: result })))
        .finally(() => setTranslating(false));
    } else {
      setTranslatedContents((v) => ({ ...v, [currentId]: '' }));
    }
  }, [currentId, translationLanguage, translator]);
  return (
    <div ref={ref} {...restProps}>
      <TranslationLanguageMenu value={translationLanguage} onChange={setTranslationLanguage} />
      {isTranslating && <LinearProgress variant="query" />}
      {translationLanguage && disclaimerText && (
        <Alert variant="outlined" severity="warning">
          {disclaimerText}
        </Alert>
      )}
      <StaticPageContent content={translatedContents[currentId] || contents[currentId]} />
    </div>
  );
};

export default forwardRef(TranslatablePageContents);
